import type React from "react";
import constate from "constate";
import type { DateSettings, OverrideTenant } from "../../../app/apolloClient";

export interface ApolloSettingsContextValue {
  overrideTenant: OverrideTenant | undefined;
  tenantId: string;
  setTenantId: React.Dispatch<React.SetStateAction<string>>;
  workspaceId: string | undefined;
  setWorkspaceId: (
    newWorkspaceId: string | undefined,
    isActive?: boolean
  ) => void;
  dateSettings: DateSettings;
  setDateSettings: (changes: Partial<DateSettings>) => void;
  clearDateSettings: () => void;
  getTokenSilently: () => Promise<string>;
  loginWithRedirect?: (opts: {
    appState: { targetUrl: string };
  }) => Promise<void>;
  workspaceChanged: boolean;
  setWorkspaceChanged: (value: boolean) => void;
  apiUrl: string;
}

const useApolloSettingsContext = (values: ApolloSettingsContextValue) => values;

const [
  Provider,
  useApolloSettings,
  useActiveTenant,
  useTenantId,
  useWorkspaceId,
  useSetWorkspaceId,
  useDateSettings,
  useSetDateSettings,
  useClearDateSettings,
  useWorkspaceChanged,
  useSetWorkspaceChanged,
] = constate(
  useApolloSettingsContext,
  (value) => value,
  (value) => value.overrideTenant,
  (value) => value.tenantId,
  (value) => value.workspaceId,
  (value) => value.setWorkspaceId,
  (value) => value.dateSettings,
  (value) => value.setDateSettings,
  (value) => value.clearDateSettings,
  (value) => value.workspaceChanged,
  (value) => value.setWorkspaceChanged
);

export {
  Provider,
  useApolloSettings,
  useActiveTenant,
  useTenantId,
  useWorkspaceId,
  useSetWorkspaceId,
  useDateSettings,
  useSetDateSettings,
  useClearDateSettings,
  useWorkspaceChanged,
  useSetWorkspaceChanged,
};
